module.exports = __webpack_public_path__ + "img/bottomold.b1d94050.png";